import { useEffect, useRef } from 'react';

import HomeCarouselAnalyticsService from '@/services/homeCarouselAnalytics.service';

const INTERSECTION_THRESHOLD = 0.25;

export default function useCarouselImpressionTracking(trackingContext = {}) {
  const targetRef = useRef(null);
  const hasTrackedRef = useRef(false);

  const {
    collectionId,
    collectionName,
    carouselType,
    contentMode,
    position,
    isMobile,
  } = trackingContext;

  useEffect(() => {
    if (hasTrackedRef.current) {
      return undefined;
    }

    const trackImpression = () => {
      if (hasTrackedRef.current) {
        return;
      }

      hasTrackedRef.current = true;

      HomeCarouselAnalyticsService.trackHomeCarouselEvent('carousel_impression', {
        collectionId,
        collectionName,
        carouselType,
        contentMode,
        position,
        isMobile,
      });
    };

    const target = targetRef.current;
    if (!target) {
      return undefined;
    }

    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
      trackImpression();
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= INTERSECTION_THRESHOLD) {
            trackImpression();
            observer.disconnect();
            break;
          }
        }
      },
      {
        threshold: [INTERSECTION_THRESHOLD],
      }
    );

    observer.observe(target);

    return () => {
      observer.disconnect();
    };
  }, [
    collectionId,
    collectionName,
    carouselType,
    contentMode,
    position,
    isMobile,
  ]);

  return targetRef;
}
